import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { RENACER_ALMA_NAME, RENACER_ALMA_STEPS } from './combo-config'

const RenacerAlma = () => (
    <ComboWizard
        comboName={RENACER_ALMA_NAME}
        steps={RENACER_ALMA_STEPS}
        bgClass="bg-renacer-alma"
        interpretStep={interpretStep}
    />
)

export default RenacerAlma
